var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h2',[_vm._t("default",function(){return [_c('svg-icon',{staticClass:"icon",attrs:{"icon-class":"icon_book"}}),_c('span',[_vm._v("文物保护部门规章")])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }